<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.stock_search_tips') || '条码/款号/名称/库位 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
      destroy-on-close
      append-to-body
    >
      <el-form ref="form" :model="form" label-width="120px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.stock_form_sample_barcode') || '样品条码'"
            >
              <el-input
                v-model.trim="form.sampleBarcode"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.stock_form_sample_no') || '样品款号'"
            >
              <el-input
                v-model.trim="form.sampleStyleNo"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.stock_form_sample_name') || '样品名称'"
            >
              <el-input
                v-model.trim="form.sampleName"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.stock_form_location_no') || '存放库位'"
            >
              <el-input
                v-model.trim="form.locationNo"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: ''
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm }
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = {
        keyword: '',
        sampleStyleNo: ''
      }
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
